"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[989],{

/***/ 8989:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ DropDownMenu)
/* harmony export */ });
const otherDropdowns = document.querySelectorAll('dropdown-menu')
if (!customElements.get('dropdown-menu')) {
  customElements.define(
    'dropdown-menu',
    class CustomDialog extends HTMLElement {
      constructor() {
        super()
        this.trigger = this.querySelector('[data-trigger]')

        this.useInert = this.dataset.useInert === 'true'
        this.toggleSticky = this.dataset.toggleSticky === 'true'
        this.index = this.dataset.index
        if (this.useInert) {
          this.inertTarget = this.querySelector('[data-inert-target]')
          this.inertTarget = this.querySelector('[data-inert-target]')
        }

        if (this.trigger) {
          this.trigger.addEventListener('click', this.toggleOpen.bind(this))
        }
        this.openMenu = this.openMenu.bind(this)
        this.closeMenu = this.closeMenu.bind(this)
        this.handleToggleSticky = this.handleToggleSticky.bind(this)
      }

      toggleOpen(event) {
        const isOpen = this.dataset.isOpen === 'true'

        if (isOpen) {
          this.closeMenu()
        } else {
          this.openMenu()
        }

        if (this.toggleSticky) {
          this.handleToggleSticky()
        }
      }

      openMenu() {
        const isOpen = this.dataset.isOpen === 'true'
        if (isOpen) return
        otherDropdowns.forEach((dropdown) => {
          if (dropdown !== this) {
            dropdown.closeMenu()
          }
        })
        this.dataset.isOpen = 'true'
        if (this.useInert) {
          this.inertTarget.removeAttribute('inert')
        }
      }

      closeMenu() {
        const isOpen = this.dataset.isOpen === 'true'
        if (!isOpen) return
        this.dataset.isOpen = 'false'
        if (this.useInert) {
          this.inertTarget.setAttribute('inert', '')
        }
      }

      handleToggleSticky() {
        const stickyDropdowns = [...otherDropdowns].filter((item) => item.dataset.toggleSticky === 'true')
        const isOpen = stickyDropdowns.some((item) => item.dataset.isOpen === 'true')
        const index = parseInt(this.index)
        if (isOpen) {
          stickyDropdowns.forEach((item) => {
            const itemIndex = parseInt(item.dataset.index)
            if (itemIndex >= this.index) {
              item.parentElement.classList.remove('tw-sticky', 'tw-top-44')
              item.parentElement.classList.add('tw-relative')
            }
          })
        } else {
          stickyDropdowns.forEach((item) => {
            item.parentElement.classList.add('tw-sticky', 'tw-top-44')
            item.parentElement.classList.remove('tw-relative')
          })
        }
      }
    }
  )
}

function DropDownMenu() {
  return null
}


/***/ })

}]);